module.exports = __webpack_public_path__ + "assets/img/Rosemary-Health-1-Social-Static-Ad-w960.8a96e8fc.png";